import { render, staticRenderFns } from "./MetrcGlobalPref.vue?vue&type=template&id=286794cb&scoped=true"
import script from "./MetrcGlobalPref.vue?vue&type=script&lang=js"
export * from "./MetrcGlobalPref.vue?vue&type=script&lang=js"
import style0 from "./MetrcGlobalPref.vue?vue&type=style&index=0&id=286794cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286794cb",
  null
  
)

export default component.exports